import { UIHeading1, UIText1 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import realtorImg from './assets/realtor.svg';
import salesmanImg from './assets/salesman.svg';
import searcherImg from './assets/searcher.svg';
import * as styles from './styles.css';
import { ImageBox } from '../InfoCardImg';

interface IInfoCard {
  title: string;
  text: string;
  role: string;
  isReversed?: boolean;
}

type IRolesParameters = {
  img: string;
  className: string;
};
interface IRoles {
  [prop: string]: IRolesParameters;
}

export function InfoCard({ title, text, role, isReversed = false }: IInfoCard) {
  const classNameContainer = isReversed
    ? cn(styles['card_container'], styles['card_container--reverse'])
    : styles['card_container'];

  const classNameImgReversed = cn(styles['info_card-img'], styles['info_card-img--reverse']);

  const classNameImg = isReversed ? classNameImgReversed : styles['info_card-img'];

  const rolesEnum: IRoles = {
    realtor: {
      img: realtorImg,
      className: cn(classNameImg, styles['info_card-img--realtor']),
    },
    searcher: {
      img: searcherImg,
      className: cn(classNameImg, styles['info_card-img--searcher']),
    },
    salesman: {
      img: salesmanImg,
      className: cn(classNameImg, styles['info_card-img--salesman']),
    },
  };

  return (
    <section data-testid="InfoCard" className={styles['card']}>
      <div className={classNameContainer}>
        <div className={styles['info_card']}>
          <div className={styles['info_card-title']}>
            <UIHeading1 data-testid={`InfoCardTitle-${role}`} as="h2">
              {title}
            </UIHeading1>
          </div>
          <UIText1 as="p">{text}</UIText1>
        </div>
        <ImageBox className={rolesEnum[role as keyof IRoles].className} imgSrc={rolesEnum[role].img} />
      </div>
    </section>
  );
}
